module.exports = "/_next/static/images/freecharge-duotone-0478e7df848273e2e3ba9c8de74dbb37.svg";